exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-item-unit{color:#063768;transform:translateX(-40px)}.input-text-color{color:#063768}.input-max-width{max-width:150px;font-weight:700}.radio-tab-checked{background-color:red}.inlet-wrapp ul[role=\"tablist\"] li input[type=\"radio\"]+.cs-radio{background:none}.inlet-wrapp ul[role=\"tablist\"] li input[type=\"radio\"]:checked+.cs-radio.active{background-color:#40a3d5 !important}.inlet-wrapp ul[role=\"tablist\"] li input[type=\"radio\"]:disabled+.cs-radio.disabled{background-color:#e9eff4 !important;border-color:#ccd7e1 !important;color:#aabacc !important;cursor:not-allowed}\n", ""]);

// exports
